(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ef-before-after-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlider(slider) {
    if (slider.dataset.efBafInit) return;
    slider.dataset.efBafInit = 'true';

    var before = slider.querySelector('[data-ef-baf-before]');
    var handle = slider.querySelector('[data-ef-baf-handle]');
    var dragging = false;

    function setPosition(clientX) {
      var rect = slider.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      before.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
    }

    slider.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    slider.addEventListener('pointerdown', function (e) {
      dragging = true;
      e.preventDefault();
      if (slider.setPointerCapture) slider.setPointerCapture(e.pointerId);
      setPosition(e.clientX);
    });
    slider.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      e.preventDefault();
      setPosition(e.clientX);
    });
    slider.addEventListener('pointerup', function () { dragging = false; });
    slider.addEventListener('pointercancel', function () { dragging = false; });
    slider.addEventListener('pointerleave', function () { dragging = false; });
  }

  document.querySelectorAll('[data-ef-baf-slider]').forEach(initSlider);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ef-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;
  if (reduceMotion || !fine) return;

  document.querySelectorAll('[data-ef-tilt]').forEach(function (wrap) {
    var img = wrap.querySelector('.ef-hero__media-main');
    var shadow = wrap.querySelector('.ef-hero__media-shadow');
    if (!img) return;

    var raf = null;

    wrap.addEventListener('mousemove', function (e) {
      var rect = wrap.getBoundingClientRect();
      var px = (e.clientX - rect.left) / rect.width - 0.5;
      var py = (e.clientY - rect.top) / rect.height - 0.5;

      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var rotateY = px * 14;
        var rotateX = py * -14;
        img.style.transform = 'rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
        if (shadow) {
          shadow.style.transform = 'translate(' + px * -16 + 'px, ' + py * -8 + 'px)';
        }
      });
    });

    wrap.addEventListener('mouseleave', function () {
      if (raf) cancelAnimationFrame(raf);
      img.style.transform = 'rotateX(0deg) rotateY(0deg)';
      if (shadow) shadow.style.transform = 'translate(0, 0)';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ef-product-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
class EfPlanSelector extends HTMLElement {
  connectedCallback() {
    this.variants = [];
    try {
      this.variants = JSON.parse(this.dataset.variants || '[]');
    } catch (err) {
      this.variants = [];
    }

    this.section = this.closest('[data-ef-purchase]');
    this.allThumbs = this.section ? Array.from(this.section.querySelectorAll('[data-ef-thumb]')) : [];
    this.colorThumbs = this.allThumbs.filter((t) => t.hasAttribute('data-ef-color-thumb'));
    this.dotsEl = this.section ? this.section.querySelector('[data-ef-dots]') : null;
    this.carouselIndex = 0;

    if (this.dotsEl && this.allThumbs.length) {
      this.allThumbs.forEach((_, i) => {
        const dot = document.createElement('span');
        if (i === 0) dot.setAttribute('data-ef-active', '');
        dot.addEventListener('click', () => this.goToSlide(i));
        this.dotsEl.appendChild(dot);
      });
    }

    const checkedPlan = this.querySelector('.ef-plan__radio:checked');
    this.selectedPlan = checkedPlan ? checkedPlan.value : (this.variants[0] ? this.variants[0].plan : '');
    this.planValues = Array.from(new Set(this.variants.map((v) => v.plan)));

    const colorValues = Array.from(new Set(this.variants.map((v) => v.color).filter(Boolean)));
    this.selectedColorSingle = colorValues[0] || '';
    this.selectedColorDuo1 = colorValues[0] || '';
    this.selectedColorDuo2 = colorValues[1] || colorValues[0] || '';

    this.singleColorPanel = this.section.querySelector('[data-ef-color-single]');
    this.duoColorPanel = this.section.querySelector('[data-ef-color-duo]');

    this.allThumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        this.goToSlide(i);
        if (thumb.hasAttribute('data-ef-color-thumb') && this.selectedPlan === this.planValues[0]) {
          this.selectedColorSingle = thumb.dataset.color;
          this.syncSwatches('single', this.selectedColorSingle);
          this.update();
        }
      });
    });

    const carousel = this.section.querySelector('[data-ef-carousel]');
    const prevBtn = carousel ? carousel.querySelector('[data-ef-carousel-prev]') : null;
    const nextBtn = carousel ? carousel.querySelector('[data-ef-carousel-next]') : null;
    if (prevBtn) prevBtn.addEventListener('click', () => this.goToSlide(this.carouselIndex - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => this.goToSlide(this.carouselIndex + 1));

    const mainEl = this.section.querySelector('[data-ef-gallery-main]');
    if (mainEl) {
      let dragging = false;
      let startX = 0;

      mainEl.addEventListener('dragstart', (e) => {
        e.preventDefault();
      });

      mainEl.addEventListener('pointerdown', (e) => {
        dragging = true;
        startX = e.clientX;
        if (mainEl.setPointerCapture) mainEl.setPointerCapture(e.pointerId);
      });
      mainEl.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        e.preventDefault();
      });
      mainEl.addEventListener('pointerup', (e) => {
        if (!dragging) return;
        dragging = false;
        const delta = e.clientX - startX;
        if (Math.abs(delta) > 40) {
          if (delta < 0) this.goToSlide(this.carouselIndex + 1);
          else this.goToSlide(this.carouselIndex - 1);
        }
      });
      mainEl.addEventListener('pointercancel', () => { dragging = false; });
      mainEl.addEventListener('pointerleave', () => { dragging = false; });
    }

    this.addEventListener('change', (event) => {
      if (!event.target.matches('[data-ef-plan-radio]')) return;
      this.selectedPlan = event.target.value;
      this.togglePlanUI();
      this.update();
    });

    Array.from(this.section.querySelectorAll('[data-ef-swatch]')).forEach((swatch) => {
      swatch.addEventListener('click', () => {
        const group = swatch.closest('[data-ef-swatch-group]');
        const groupName = group ? group.dataset.efSwatchGroup : 'single';
        const color = swatch.dataset.color;
        this.syncSwatches(groupName, color);
        if (groupName === 'single') {
          this.selectedColorSingle = color;
          const label = this.section.querySelector('[data-ef-color-label]');
          if (label) label.textContent = color;
          const thumbMatch = this.colorThumbs.find((t) => t.dataset.color === color);
          if (thumbMatch) this.goToSlide(this.allThumbs.indexOf(thumbMatch));
        } else if (groupName === 'duo1') {
          this.selectedColorDuo1 = color;
          const label = this.section.querySelector('[data-ef-color-label-1]');
          if (label) label.textContent = color;
        } else if (groupName === 'duo2') {
          this.selectedColorDuo2 = color;
          const label = this.section.querySelector('[data-ef-color-label-2]');
          if (label) label.textContent = color;
        }
        this.update();
      });
    });

    this.togglePlanUI();
    this.update(true);
  }

  syncSwatches(groupName, color) {
    const group = this.section.querySelector('[data-ef-swatch-group="' + groupName + '"]');
    if (!group) return;
    Array.from(group.querySelectorAll('[data-ef-swatch]')).forEach((s) => {
      if (s.dataset.color === color) s.setAttribute('data-ef-active', '');
      else s.removeAttribute('data-ef-active');
    });
  }

  togglePlanUI() {
    const isDuo = this.planValues.indexOf(this.selectedPlan) === 1;
    if (this.singleColorPanel) this.singleColorPanel.hidden = isDuo;
    if (this.duoColorPanel) this.duoColorPanel.hidden = !isDuo;
  }

  goToSlide(index) {
    const count = this.allThumbs.length;
    if (!count) return;
    this.carouselIndex = (index + count) % count;
    const thumb = this.allThumbs[this.carouselIndex];
    this.allThumbs.forEach((t) => t.removeAttribute('data-ef-active'));
    thumb.setAttribute('data-ef-active', '');
    const mainImage = this.section.querySelector('[data-ef-gallery-main]');
    if (mainImage && thumb.dataset.fullImage) {
      const img = mainImage.querySelector('img');
      if (img) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = thumb.dataset.fullImage;
      }
    }
    if (this.dotsEl) {
      Array.from(this.dotsEl.children).forEach((dot, i) => {
        if (i === this.carouselIndex) dot.setAttribute('data-ef-active', '');
        else dot.removeAttribute('data-ef-active');
      });
    }
  }

  findVariant(plan, color) {
    return this.variants.find((v) => v.plan === plan && v.color === color);
  }

  update(silent) {
    if (!this.section) return;
    const isDuo = this.planValues.indexOf(this.selectedPlan) === 1;
    const variantInput = this.section.querySelector('[data-ef-variant-input]');
    const submitLabel = this.section.querySelector('[data-ef-submit-label]');
    const stickyLabel = document.querySelector('[data-ef-sticky-label]');
    const stickyPrice = document.querySelector('[data-ef-sticky-price]');

    if (isDuo) {
      const v1 = this.findVariant(this.planValues[0], this.selectedColorDuo1);
      const v2 = this.findVariant(this.planValues[0], this.selectedColorDuo2);
      const duoVariant = this.findVariant(this.selectedPlan, this.selectedColorDuo1) || this.variants.find((v) => v.plan === this.selectedPlan);
      this.duoLineItems = (v1 && v2) ? [v1.id, v2.id] : null;
      if (variantInput && duoVariant) variantInput.value = duoVariant.id;
      if (submitLabel && duoVariant) submitLabel.textContent = 'Add to Cart — ' + duoVariant.price;
      if (stickyLabel) stickyLabel.textContent = this.selectedPlan + ' (' + this.selectedColorDuo1 + ' + ' + this.selectedColorDuo2 + ')';
      if (stickyPrice && duoVariant) stickyPrice.textContent = duoVariant.price;
    } else {
      this.duoLineItems = null;
      const variant = this.findVariant(this.selectedPlan, this.selectedColorSingle) || this.variants[0];
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (submitLabel) submitLabel.textContent = 'Add to Cart — ' + variant.price;
      if (stickyLabel) stickyLabel.textContent = variant.plan + (variant.color ? ' / ' + variant.color : '');
      if (stickyPrice) stickyPrice.textContent = variant.price;
    }

    if (!silent) {
      document.dispatchEvent(new CustomEvent('ef:variant-change', {}));
    }
  }
}
if (!customElements.get('ef-plan-selector')) customElements.define('ef-plan-selector', EfPlanSelector);

document.querySelectorAll('[data-ef-purchase]').forEach((section) => {
  const form = section.querySelector('#ef-purchase-form');
  if (!form) return;
  const selectorEl = section.querySelector('ef-plan-selector');

  async function submitAddToCart() {
    const errorEl = section.querySelector('[data-ef-error]');
    if (errorEl) errorEl.hidden = true;
    let items;
    if (selectorEl && selectorEl.duoLineItems) {
      items = selectorEl.duoLineItems.map((id) => ({ id: id, quantity: 1 }));
    } else {
      const variantInput = form.querySelector('[data-ef-variant-input]');
      items = [{ id: variantInput.value, quantity: 1 }];
    }
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      });
      if (!response.ok) throw new Error('add_failed');
      window.location.href = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart' : '/cart';
    } catch (err) {
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.textContent = 'Something went wrong adding this to your cart. Please try again.';
      }
    }
  }

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    submitAddToCart();
  });

  const stickyBtn = document.querySelector('[data-ef-sticky-submit]');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', () => submitAddToCart());
  }

  const stickyCart = document.querySelector('[data-ef-sticky-cart]');
  if (stickyCart && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        stickyCart.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      },
      { threshold: 0 }
    );
    observer.observe(section);
  }
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ef-purchase"] && !Shopify.designMode) return;
  try {
    
(function () {
class EfPlanSelector extends HTMLElement {
  connectedCallback() {
    this.variants = [];
    try {
      this.variants = JSON.parse(this.dataset.variants || '[]');
    } catch (err) {
      this.variants = [];
    }

    this.section = this.closest('[data-ef-purchase]');
    this.thumbs = this.section ? Array.from(this.section.querySelectorAll('[data-ef-color-thumb]')) : [];

    const checkedPlan = this.querySelector('.ef-plan__radio:checked');
    this.selectedPlan = checkedPlan ? checkedPlan.value : (this.variants[0] ? this.variants[0].plan : '');

    const defaultThumb = this.thumbs[0];
    this.selectedColor = defaultThumb ? defaultThumb.dataset.color : (this.variants[0] ? this.variants[0].color : '');
    if (defaultThumb) defaultThumb.setAttribute('data-ef-active', '');

    this.addEventListener('change', (event) => {
      if (!event.target.matches('[data-ef-plan-radio]')) return;
      this.selectedPlan = event.target.value;
      this.update();
    });

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        this.selectedColor = thumb.dataset.color;
        this.thumbs.forEach((t) => t.removeAttribute('data-ef-active'));
        thumb.setAttribute('data-ef-active', '');
        const mainImage = this.section.querySelector('[data-ef-gallery-main]');
        if (mainImage && thumb.dataset.fullImage) {
          const img = mainImage.querySelector('img');
          if (img) img.src = thumb.dataset.fullImage;
        }
        const colorLabel = this.querySelector('[data-ef-color-label]');
        if (colorLabel) colorLabel.textContent = this.selectedColor;
        this.update();
      });
    });

    this.update(true);
  }

  findVariant() {
    return this.variants.find((v) => v.plan === this.selectedPlan && (v.color === this.selectedColor || !v.color)) || this.variants[0];
  }

  update(silent) {
    if (!this.section) return;
    const variant = this.findVariant();
    if (!variant) return;

    const variantInput = this.section.querySelector('[data-ef-variant-input]');
    const submitLabel = this.section.querySelector('[data-ef-submit-label]');
    if (variantInput) variantInput.value = variant.id;
    if (submitLabel) submitLabel.textContent = 'Add to Cart — ' + variant.price;

    const stickyLabel = document.querySelector('[data-ef-sticky-label]');
    const stickyPrice = document.querySelector('[data-ef-sticky-price]');
    if (stickyLabel) stickyLabel.textContent = variant.plan + (variant.color ? ' / ' + variant.color : '');
    if (stickyPrice) stickyPrice.textContent = variant.price;

    if (!silent) {
      document.dispatchEvent(new CustomEvent('ef:variant-change', { detail: { variantId: variant.id } }));
    }
  }
}
if (!customElements.get('ef-plan-selector')) customElements.define('ef-plan-selector', EfPlanSelector);

document.querySelectorAll('[data-ef-purchase]').forEach((section) => {
  const form = section.querySelector('#ef-purchase-form');
  if (!form) return;

  async function submitAddToCart(variantId) {
    const errorEl = section.querySelector('[data-ef-error]');
    if (errorEl) errorEl.hidden = true;
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });
      if (!response.ok) throw new Error('add_failed');
      window.location.href = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart' : '/cart';
    } catch (err) {
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.textContent = 'Something went wrong adding this to your cart. Please try again.';
      }
    }
  }

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const variantInput = form.querySelector('[data-ef-variant-input]');
    if (variantInput) submitAddToCart(variantInput.value);
  });

  const stickyBtn = document.querySelector('[data-ef-sticky-submit]');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', () => {
      const variantInput = form.querySelector('[data-ef-variant-input]');
      if (variantInput) submitAddToCart(variantInput.value);
    });
  }

  const stickyCart = document.querySelector('[data-ef-sticky-cart]');
  if (stickyCart && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        stickyCart.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      },
      { threshold: 0 }
    );
    observer.observe(section);
  }
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ef-results-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
class EfCarousel extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-ef-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-ef-dot]'));
    this.index = 0;
    this.render();

    const prev = this.querySelector('[data-ef-prev]');
    const next = this.querySelector('[data-ef-next]');
    if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
    if (next) next.addEventListener('click', () => this.go(this.index + 1));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));
  }

  go(i) {
    const count = this.slides.length;
    this.index = (i + count) % count;
    this.render();
  }

  render() {
    this.slides.forEach((slide, i) => {
      if (i === this.index) slide.setAttribute('data-ef-active', '');
      else slide.removeAttribute('data-ef-active');
    });
    this.dots.forEach((dot, i) => {
      if (i === this.index) dot.setAttribute('data-ef-active', '');
      else dot.removeAttribute('data-ef-active');
    });
  }
}
if (!customElements.get('ef-carousel')) customElements.define('ef-carousel', EfCarousel);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ef-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
class EfCarousel extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-ef-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-ef-dot]'));
    this.index = 0;
    this.render();

    const prev = this.querySelector('[data-ef-prev]');
    const next = this.querySelector('[data-ef-next]');
    if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
    if (next) next.addEventListener('click', () => this.go(this.index + 1));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));
  }

  go(i) {
    const count = this.slides.length;
    this.index = (i + count) % count;
    this.render();
  }

  render() {
    this.slides.forEach((slide, i) => {
      if (i === this.index) slide.setAttribute('data-ef-active', '');
      else slide.removeAttribute('data-ef-active');
    });
    this.dots.forEach((dot, i) => {
      if (i === this.index) dot.setAttribute('data-ef-active', '');
      else dot.removeAttribute('data-ef-active');
    });
  }
}
if (!customElements.get('ef-carousel')) customElements.define('ef-carousel', EfCarousel);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
